import { Component, Input, OnInit, forwardRef } from '@angular/core';
import {
  ControlValueAccessor,
  NG_VALUE_ACCESSOR,
  NG_VALIDATORS,
  Validator,
  AbstractControl,
  ValidationErrors,
} from '@angular/forms';

@Component({
  selector: 'app-cost-pricing-input',
  templateUrl: './cost-pricing-input.component.html',
  styleUrls: ['./cost-pricing-input.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => CostPricingInputComponent),
      multi: true,
    },
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => CostPricingInputComponent),
      multi: true,
    },
  ],
})
export class CostPricingInputComponent implements OnInit, ControlValueAccessor, Validator {
  @Input() prefix: string = '₹';
  @Input() readonly: boolean = false;
  @Input() disableDrowdown: boolean = false;
  @Input() invalidInput: any;
  @Input() placeHolder: any = 'Enter amount';
  @Input() dropdownArray: any[] = [];

  value = {
    inputValue: '0',
    dropdownValue: 1,
  };

  onChange = (value: any) => {};
  onTouched = () => {};

  constructor() {}

  ngOnInit() {}

  writeValue(value: any): void {
    if (value) {
      this.value = value;
      this.updateValue();
    }
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    this.readonly = isDisabled;
  }

  onInputChange(event: any): void {
    const input = event.target as HTMLInputElement;
    let val = input.value;

    // Allow only digits and dot
    val = val.replace(/[^0-9.]/g, '');

    // Keep only first dot
    const firstDot = val.indexOf('.');
    if (firstDot !== -1) {
      const beforeDot = val.substring(0, firstDot + 1);
      const afterDot = val.substring(firstDot + 1).replace(/\./g, '');
      // Restrict to max 2 decimals
      val = beforeDot + afterDot.slice(0, 2);
    }

    this.value.inputValue = val;
    input.value = val;
    this.updateValue();
  }

  onDropdownChange(event: any): void {
    this.value.dropdownValue = event.target.value;
    this.updateValue();
  }

  updateValue(): void {
    this.onChange(this.value);
    this.onTouched();
  }

  // Validation function to check if inputValue should be required
  validate(control: AbstractControl): ValidationErrors | null {
    const value = control.value;
  
    if (
      value.dropdownValue !== 0 &&
      (value.inputValue === null || value.inputValue === undefined || value.inputValue === '' || value.inputValue < 0)
    ) {
      // If dropdownValue is not 0 and inputValue is null, undefined, empty string, or less than 0
      return { required: true };
    }
  
    // If dropdownValue is 0, inputValue can be optional
    return null;
  }

  onBlur(): void {
    if (this.value) {
      const num = parseFloat(this.value.inputValue);
      if (!isNaN(num)) {
        this.value.inputValue = num.toFixed(2); // enforce 2 decimals
        this.onChange(this.value);
      } else {
        this.value.inputValue = '';
        this.onChange(this.value);
      }
    }
  }  
  
}
